import { Stack } from "@phosphor-icons/react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { fmtDate, pts } from "@/lib/format";
import { TYPE_LABEL, summarize } from "@/lib/programs";

const STATE_STYLE = { active: "bg-emerald-100 text-emerald-700", paused: "bg-amber-100 text-amber-700", ended: "bg-black/5 text-muted-foreground", draft: "bg-muted text-muted-foreground" };

const dates = (p) => (p.start_date || p.end_date)
  ? `${p.start_date ? fmtDate(p.start_date) : "Any time"} → ${p.end_date ? fmtDate(p.end_date) : "No end"}`
  : "Always on";

const ProgramRow = ({ p }) => (
  <div className="p-4 flex items-start justify-between gap-3 flex-wrap" data-testid={`admin-program-${p.id}`}>
    <div className="min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <p className="font-medium text-sm" data-testid="admin-program-name">{p.name}</p>
        <span className={`text-[11px] px-2 py-0.5 rounded-full capitalize ${STATE_STYLE[p.state] || STATE_STYLE.draft}`} data-testid="admin-program-state">{p.state}</span>
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        <span data-testid="admin-program-type">{TYPE_LABEL[p.type] || p.type}</span> · <span data-testid="admin-program-rule">{summarize(p)}</span>
      </p>
      <p className="text-xs text-muted-foreground mt-0.5" data-testid="admin-program-dates">{dates(p)}</p>
    </div>
    <div className="text-right">
      <p className="font-display font-bold text-lg" data-testid="admin-program-points">{p.type === "stamp" ? "—" : pts(p.points_issued)}</p>
      <p className="text-[11px] text-muted-foreground">{p.type === "stamp" ? "stamp card" : "pts issued"}</p>
    </div>
  </div>
);

const List = ({ items, empty, testid }) => (
  <div className="card-surface divide-y divide-black/5" data-testid={testid}>
    {items.length === 0 && <p className="text-sm text-muted-foreground p-4">{empty}</p>}
    {items.map((p) => <ProgramRow key={p.id} p={p} />)}
  </div>
);

export const AdminBusinessPrograms = ({ programs = [] }) => {
  const active = programs.filter((p) => p.state === "active");
  const inactive = programs.filter((p) => p.state !== "active");
  return (
    <div data-testid="admin-business-programs">
      <p className="text-xs uppercase tracking-wider font-mono text-muted-foreground mb-2 flex items-center gap-1"><Stack size={14} /> Loyalty programs</p>
      <Tabs defaultValue="active">
        <TabsList className="mb-3">
          <TabsTrigger value="active" data-testid="admin-programs-tab-active">Active ({active.length})</TabsTrigger>
          <TabsTrigger value="inactive" data-testid="admin-programs-tab-inactive">Paused / ended ({inactive.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="active"><List items={active} empty="No active programs." testid="admin-programs-active-list" /></TabsContent>
        <TabsContent value="inactive"><List items={inactive} empty="No paused or ended programs." testid="admin-programs-inactive-list" /></TabsContent>
      </Tabs>
    </div>
  );
};
